import nextbike from "./../static/icons/nextbike_count.png";
import parking from "./../static/icons/bicycle_parking.png";
import { LatLngTuple } from "leaflet";

//LAYERS BUTTONS definition for right side - but hidden now

//area
//area[name="Sosnowiec"]->.sosnowiec;

export enum LayerType {
  MARKER = 'marker',
  WAY = 'way'
}



// Layer Mapping type
export type LayerMapping = {
  key: string;
  label: string;
  query: string;
  icon: string;
  type: LayerType; //string | undefined;
};

// Mapping Layers <=> Overpass queries
export const layers: LayerMapping[] = [
  {
    key: "bicycle_parking",
    label: "Parkingi rowerowe",
    icon: parking,
    type: LayerType.MARKER,
    query: `
      relation[AREA][amenity="bicycle_parking"];
      node[AREA][amenity="bicycle_parking"];
      way[AREA][amenity="bicycle_parking"];
      `
  },
  {
    key: "compressed_air",
    label: "compressed_air",
    icon: parking,
    type: LayerType.MARKER,
    query: `
      relation[AREA][amenity="compressed_air"];
      node[AREA][amenity="compressed_air"];
      way[AREA][amenity="compressed_air"];
      `
  },
  {
    key: "bicycle_rental",
    label: "Stacje rowerowe",
    icon: nextbike,
    type: LayerType.MARKER,
    query: `
      relation[AREA][amenity="bicycle_rental"]["brand:wikidata" = "Q55754308"];
      node[AREA][amenity="bicycle_rental"]["brand:wikidata" = "Q55754308"];
      way[AREA][amenity="bicycle_rental"]["brand:wikidata" = "Q55754308"];
      `
  },
  {
    key: "bicycleways",
    label: "Bicycleways",
    icon: parking,
    type: LayerType.WAY,
    query: `
      relation[AREA][type="route"][route="bicycle"];

      way[AREA][highway="cycleway"];
      way[AREA][highway="path"]["bicycle"~"^(yes|designated|permissive)$"];
      way[AREA][highway="footway"]["bicycle"~"^(yes|designated|permissive)$"];
      way[AREA][highway="pedestrian"]["bicycle"~"^(yes|designated|permissive)$"];

      way[AREA][highway][cycleway~"^(lane|track|shared_lane|share_busway|shoulder|separate)$"];
      way[AREA][highway]["cycleway:left"~"^(lane|track|shared_lane|share_busway|shoulder|separate)$"];
      way[AREA][highway]["cycleway:right"~"^(lane|track|shared_lane|share_busway|shoulder|separate)$"];
      way[AREA][highway]["cycleway:both"~"^(lane|track|shared_lane|share_busway|shoulder|separate)$"];

      way[AREA][highway]["oneway:bicycle"="no"];
      way[AREA][highway="living_street"];
      way[AREA][highway~"^(residential|service|unclassified|tertiary|secondary|primary)$"][maxspeed~"^(10|20|30)$"];
      way[AREA][highway~"^(residential|service|unclassified|tertiary|secondary|primary)$"]["zone:maxspeed"~"^PL:(10|20|30)$"];
      way[AREA][highway~"^(residential|service|unclassified|tertiary|secondary|primary)$"]["source:maxspeed"~"^PL:zone30$|^PL:zone$"];

      way[AREA][highway="track"];
      way[AREA][highway="path"]["bicycle"!~"^(no|dismount|private)$"];
      way[AREA][highway~"^(track|path)$"][surface~"^(unpaved|compacted|fine_gravel|gravel|pebblestone|ground|dirt|earth|grass|mud|sand|woodchips)$"];
      way[AREA][highway~"^(track|path)$"][tracktype~"^(grade1|grade2|grade3|grade4|grade5)$"];

      way[AREA][highway~"^(residential|service|unclassified|tertiary|secondary|primary)$"]
        ["bicycle"!~"^(no|dismount|private)$"]
        ["motorroad"!="yes"]
        ["cycleway"];
      `
  },
  // {
  //   key: "college",
  //   label: "Colleges",
  //   icon: school,
  //   query: `
  //     node["amenity"="college"][BOX];
  //   `
  // },
  // {
  //   key: "school",
  //   label: "Schools",
  //   icon: primary,
  //   query: `
  //     node["amenity"="school"][BOX];
  //   `
  // },
  // {
  //   key: "bus",
  //   label: "Bus stops",
  //   icon: bus,
  //   query: `
  //     node["highway"="bus_stop"][BOX];
  //   `
  // },
  // {
  //   key: "restaurant",
  //   label: "Restaurants",
  //   icon: restaurant,
  //   query: `
  //     node["amenity"="restaurant"][BOX];
  //   `
  // }
];

export type LayerMarker = {
    lat: number;
    lon: number;
    name?: string;
    icon?: any;
    popupHtml?: string;
    position?: LatLngTuple;
};

// Collection of markers found for a layer
export type LayerMarkers = {
  key: string;
  icon: string;
  markers: LayerMarker[];
};


export type PolyLine = {
  key: string | undefined;
  icon: string | undefined;
  tags: any | undefined | null;
  bikeClass?: string;
  surfaceClass?: string;
  renderStyle?: {
    color: string;
    width: number;
    opacity: number;
    dasharray: string | null;
    innerColor?: string;
    innerWidth?: number;
    innerDasharray?: string | null;
    zIndex: number;
    className: string;
    surfaceClass: string;
  } | null;
  nodes: {
    lat: number;
    lon: number;
  }[];
}


export type PolyLineMap = {
  key: string | undefined;
  icon: string | undefined;
  nodes: LatLngTuple[];
}

// „LatLngExpression[] | LatLngExpression[][]”.
//   Typu „number[][]” nie można przypisać do typu „LatLngExpression[]”.
//     Typu „number[]” nie można przypisać do typu „LatLngExpression”.
//       Typu „number[]” nie można przypisać do typu „LatLngTuple”
